module.exports = __webpack_public_path__ + "static/media/certificates.5d681227.svg";